import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { LIST_ITEMS_SIZE } from 'config';
import { CONTENT_TYPES } from 'constants/content-types';
import { ListItemCleanWrapper, LIST_ITEM_MARGIN } from 'components/ListItem';
import { StyledListTitle, StyledHorizontalList } from './StyledComponents';

const BASE_LIST_CONFIG = {
  enterTo: 'last-focused',
  debounce: {
    time: 150,
    options: {
      leading: true,
      trailing: false,
      maxWait: 200,
    },
  },
};

const CollectionList = (props) => {
  const { id, index, title, items, contentSize } = props;
  const { defaultSection, defaultIndex, startScrollIndex, config, onEnter, onFocus } = props;

  const itemSize = (LIST_ITEMS_SIZE[contentSize] || LIST_ITEMS_SIZE.LARGE).width;
  const listHeight = (LIST_ITEMS_SIZE[contentSize] || LIST_ITEMS_SIZE.LARGE).horizontalListHeight;

  const renderSize = [CONTENT_TYPES.BANNER, 'MEDIUM'].includes(contentSize) ? 4 : 8;

  const onEnterHandler = useCallback((item, i) => onEnter(item, i, { id, index }), [onEnter, id, index]);
  const onFocusHandler = useCallback((item, i) => onFocus(item, i, { id, index }), [onFocus, id, index]);

  return (
    <div key={id}>
      {![CONTENT_TYPES.BANNER, CONTENT_TYPES.SMALL_BANNER, CONTENT_TYPES.FILTERS_BANNER].includes(contentSize) && (
        <StyledListTitle>{title}</StyledListTitle>
      )}
      <StyledHorizontalList
        listId={id}
        sectionName={id}
        defaultSection={defaultSection}
        defaultIndex={defaultIndex}
        contentSize={contentSize}
        listHeight={listHeight}
        startScrollIndex={contentSize !== CONTENT_TYPES.BANNER ? startScrollIndex : 0}
        itemSize={itemSize + LIST_ITEM_MARGIN}
        items={items}
        onEnter={onEnterHandler}
        onFocus={onFocusHandler}
        config={{ ...BASE_LIST_CONFIG, ...config }}
        renderSize={renderSize}
        itemComponent={ListItemCleanWrapper}
      />
    </div>
  );
};

CollectionList.propTypes = {
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  contentSize: PropTypes.string,
  defaultSection: PropTypes.bool,
  defaultIndex: PropTypes.number,
  startScrollIndex: PropTypes.number,
  config: PropTypes.object,
  onEnter: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
};

export default CollectionList;
